/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RecordingDurationBucketFromJSON, RecordingDurationBucketToJSON } from './RecordingDurationBucket';
/**
 * Check if a given object implements the RecordingDurationResponse interface.
 */
export function instanceOfRecordingDurationResponse(value) {
    if (!('days' in value) || value['days'] === undefined)
        return false;
    if (!('free' in value) || value['free'] === undefined)
        return false;
    if (!('overall' in value) || value['overall'] === undefined)
        return false;
    if (!('paid' in value) || value['paid'] === undefined)
        return false;
    return true;
}
export function RecordingDurationResponseFromJSON(json) {
    return RecordingDurationResponseFromJSONTyped(json, false);
}
export function RecordingDurationResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'days': json['days'],
        'free': RecordingDurationBucketFromJSON(json['free']),
        'overall': RecordingDurationBucketFromJSON(json['overall']),
        'paid': RecordingDurationBucketFromJSON(json['paid']),
    };
}
export function RecordingDurationResponseToJSON(json) {
    return RecordingDurationResponseToJSONTyped(json, false);
}
export function RecordingDurationResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'days': value['days'],
        'free': RecordingDurationBucketToJSON(value['free']),
        'overall': RecordingDurationBucketToJSON(value['overall']),
        'paid': RecordingDurationBucketToJSON(value['paid']),
    };
}
